import * as types from "./types";

export const login = (username, password) => {
  return (api) => ({
    type: types.LOGIN,
    payload: api.post("v1/auth/login", { username, password }).then((res) => {
      window.localStorage.setItem("token", res.data.token);
      return res;
    }),
    hideUserErrors: true
  });
};

export const initialiseToken = () => {
  const token = window.localStorage.getItem("token");
  return {
    type: types.SET_TOKEN,
    payload: token,
  };
};

export const fetchMe = () => {
  return (api) => ({
    type: types.FETCH_ME,
    payload: api.get("v1/user/me"),
  });
};

export const fetchConfig = () => {
  return (api) => ({
    type: types.FETCH_CONFIG,
    payload: api.get("v1/config")
  });
};

export const logout = () => {
  window.localStorage.removeItem("token");
  return {
    type: types.LOGOUT,
  };
};

export const reset = () => {
  return {
    type: types.RESET,
  };
};
